export const LRPT_MSG_0001='小dō温馨提示:非常抱歉，您只能购买一套特别礼遇套装哦！<br>Tips: sorry, each one can only purchase one set of special kit'
export const LRPT_MSG_0002="小dō温馨提示:您已购买过特别礼遇套装，暂无资格再次购买！<br>Tips: sorry, you can't purchase one more set of special kit"
export const LRPT_MSG_0003='小dō温馨提示:未有购买特别礼遇套装资格，特别礼遇套装，仅供2018年12月31日之前设定过轻松购的顾客<br>Tipss: you are not qulified to purchase special kit,Only effective for the customers who set up LRP template before Dec 31, 2018'
export const LRPT_MSG_0004='小dō温馨提示:LRP轻松购特别礼遇套装只能二选一哦！<br>Tips: you can only chose one of the 2 LRP Template kits '
export const LRPT_MSG_0008='小dō温馨提示:未有购买特别礼遇套装资格，特别礼遇套装，仅供2018年12月31日之前设定过轻松购的顾客<br>Tipss: you are not qulified to purchase special kit,Only effective for the customers who set up LRP template before Dec 31, 2018'


export const LRPT_MSG_0005='小dō温馨提示:本套装只能买一个哦！<br>Tips: you can only buy one set of the kit'
export const LRPT_MSG_0006='小dō温馨提示:单笔订单满125点，才可以购买本套装哦！<br>Notice: Terrastix LRP Trio kit will be removed from your order due to insufficient pv value (125pv is required per order)'
export const LRPT_MSG_0007='小dō温馨提示:由于您的单笔订单未满125点，清畅三部曲LRP套装将被移除！<br>Tips:Ordering with less than 125PV is not qualified to have Terrastix LRP Trio kit'

export const BD_MSG_0001='可在您生日当月下单订购<br>Available in your birthday month'
export const BD_MSG_0002='生日专属礼遇套装只能购买一套<br>Birthday gift set can only buy one'
export const BD_MSG_0003="购买了生日专属礼遇不可购买其他产品哦！<br>You can't buy other products when you buy a birthday gift set."
export const BD_MSG_0004="生日专属礼遇不支持代下单哦！"





